module.exports = __webpack_public_path__ + "img/follow-me-home-guide.93f77c3b.png";